import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import RenunciaReceitaLogged from '../../../components/auth/renunciareceita'

function RenunciaReceitaLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Renúncia de Receita" />
                <HeaderLogged />
                <Container>
                   <RenunciaReceitaLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default RenunciaReceitaLoggedScreen;